
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './landingpage.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Plandingpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id689a58e68e5aed52dc7b79c1" >

      <div id="i9ol" className="">
      
      <div id="icjbu5" className="">
      
      <img
        className=""
        id="iwbvf5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhcxkni.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipwig4" className="">
      
        <a
          target=""
          className=""
          id="idtfhs"
          href="/estudios"
        >
          
    <div id="ifgmx9" className="">
    <>Estudios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivw47x"
          href={`/contact`}
        >
          
    <div id="iv1mlt" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/acerca"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/estudios"
        type=""
      >
        <>Estudios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contact"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iizt" className="">
      
      <div id="iwdy" className="">
      
      <div className="" id="i1hzn">
        <>Grandes datos, grandes ideas  </>
      </div>
      
      <div className="" id="i32i8">
        <>M2Global Insights lleva a cabo encuestas representativas a nivel   </>
      <br className="" id="" />
      <>nacional con su tecnología de recolección de datos y técnicas de   </>
      <br className="" id="" />
      <>ajuste de resultados para garantizar la precisión de la muestra.  </>
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm" className="">
      
      <div id="ihdlf" className="">
      
      <div className="" id="iekiw">
        <>Prácticas</>
      </div>
      
      <div className="" id="ia5ge">
        <>M2Global Insights provee Big Data personalizado y soluciones de tecnología</>
      <br className="" id="" />
      <>para resolver problemas complejos de negocio</>
      </div>
      
      </div>
      
      <div id="isfsn" className="">
      
      <div id="imvl9" className="">
      
      <img
        className=""
        id="iypzp"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="icwgn">
        <>Consultoría de Gestión</>
      </div>
      
      <div className="" id="igyzq">
        <>Socios de pensamiento para el alta en decisiones estratégicas importantes.</>
      </div>
      
      </div>
      
      <div id="i8el2" className="">
      
      <img
        className=""
        id="i2l1i"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="i90r8">
        <>Riesgo político</>
      </div>
      
      <div className="" id="i7vtl">
        <>Soluciones para un análisis de riesgo político de primer nivel.</>
      </div>
      
      </div>
      
      <div id="inutl" className="">
      
      <img
        className=""
        id="io84h"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="ieu7i">
        <>Herramientas de sondeo</>
      </div>
      
      <div className="" id="ipjxj">
        <>Herramientas científicas para analizar insights del consumidor en tiempo real.</>
      </div>
      
      </div>
      
      <div id="ini4p" className="">
      
      <img
        className=""
        id="i9jir"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="i8kft">
        <>Previsión</>
      </div>
      
      <div className="" id="igcag">
        <>Modelos predictivos: decisiones estratégicas y preparación ante riesgos</>
      </div>
      
      </div>
      
      <div id="ixa1h" className="">
      
      <img
        className=""
        id="ixbfo"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="i9r0c">
        <>Blockchain</>
      </div>
      
      <div className="" id="i03c2">
        <>Tecnologías de encriptación avanzada.</>
      </div>
      
      </div>
      
      <div id="ipzyz" className="">
      
      <img
        className=""
        id="itu7z"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="ip8v5">
        <>Data Dashboards</>
      </div>
      
      <div className="" id="irg88">
        <>Paneles versátiles: información clave de grandes conjuntos de datos.</>
      </div>
      
      </div>
      
      <div id="isbuu" className="">
      
      <img
        className=""
        id="i5q4b"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="ijd8f">
        <>Información de Medios</>
      </div>
      
      <div className="" id="i031f">
        <>Herramientas de microsegmentación para redes sociales y gasto publicitario.</>
      </div>
      
      </div>
      
      <div id="izdfi" className="">
      
      <img
        className=""
        id="itu1g"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7m9193.png"
        alt="undefined"
      />
      
      <div className="" id="ixxvi">
        <>Desarrollo de Apps</>
      </div>
      
      <div className="" id="igwrw">
        <>Desarrollo de soluciones móviles de punto a punto.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="irers" className="">
      
        <a
          target=""
          className=""
          id="iuuhyl"
          href="#"
        >
          
      <span className="" id="iy1fm9">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="ii5t" className="">
      
      <div id="io6yi" className="">
      
      </div>
      
      <div id="iyvwk" className="">
      
      <div id="ivlb5" className="">
      
      <div id="iw4hc" className="">
      
      <div className="" id="i3df7">
        <>Seguimiento profesional</>
      </div>
      
      <div className="" id="i6pj8">
        <>Encuestas de alta frecuencia patentadas que le permiten ser el primero en saber cuándo cambia la opinión pública y la probabilidad de resultados políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="i3aw6g"
          href="#"
        >
          
      <span className="" id="iifyiy">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iuyzc2"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="imwvvh" className="">
      
      <div id="iv9sr1" className="">
      
      <div className="" id="iin1ty">
        <>M2Global Monitor  </>
      </div>
      
      <div className="" id="ibz2nf">
        <>M2Global es una herramienta de inteligencia de redes sociales personalizable que proporciona un monitoreo granular de empresas, organizaciones, temas, campañas políticas, etc.</>
      </div>
      
        <a
          target=""
          className=""
          id="i00gff"
          href="#"
        >
          
      <span className="" id="id3vz7">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="icj4qn"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="inx1hy" className="">
      
      <div id="ijerzc" className="">
      
      <div className="" id="i8jk4i">
        <>Encuestas Públicas</>
      </div>
      
      <div className="" id="iu6t0x">
        <>Encuestas representativas a nivel nacional realizadas por M2Global   utilizando su tecnología patentada de recopilación de datos y algoritmos de post-estratificación.</>
      </div>
      
        <a
          target=""
          className=""
          id="in1c0v"
          href="#"
        >
          
      <span className="" id="iq2lzm">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iif51w"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="itkdrg" className="">
      
      <div id="icg789" className="">
      
      <div className="" id="i8sspp">
        <>M2Global Político   </>
      </div>
      
      <div className="" id="ixdzez">
        <>M2Global Político    es una plataforma de transparencia política que empodera a los ciudadanos para exigir cuentas a sus políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="ilx2im"
          href="#"
        >
          
      <span className="" id="i5r0b4">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="idv40l"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="id4e2" className="">
      
      <div className="" id="iglijz">
        <>Copyright © 2025 M2GlobalInsigths ORG</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Plandingpage);
  